import { writable } from 'svelte/store';

import type { IndustryCentroid } from '$lib/api/data';

/** Every published industry centroid, as loaded from `/deep-iq/industry-centroids`. */
export const industryCentroids = writable<IndustryCentroid[]>([]);

/**
 * Whether that list is being fetched.
 *
 * Its own flag, because the load used to borrow `queryRunning` — which means
 * a customer's search is running, and which the results screen treats as
 * proof that a search has happened. See loadPublicIndustryCentroids.
 */
export const industryCentroidsLoading = writable(false);

/**
 * The centroids the customer has picked, keyed by id and valued by name.
 *
 * A Map rather than a Set, which matters: the mode switcher used to reset this
 * with `new Set()`, and every reader builds `new Map(selection)` from it —
 * which throws on a Set, because a Set yields values where Map wants pairs.
 */
export const selectedIndustryCentroids = writable<Map<string, string>>(new Map());
